export function isUrlValid(url: string) {
	return /^http.*$/.test(url);
}
